import React, {Component} from "react";
import axios from "axios";
import store from '../store';
import { Link } from "react-router-dom";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const GigsApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/seller/`
})
const categoryApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/adminuser/categoriesAPI/`
})

class SellerGigs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gigs : [],
            categories:[],
            title:'',
            category:null,
            price:null,
            image:null,
            details:'',
            img_update:'no',
            id:null,
        }
        this.getGigs();
        this.getCategories();
    }
    getGigs = async () => {
            let data = await GigsApi.get(`GigsAPI/${store.getState().auth.user.id}/`).then(({data})=>data);
            this.setState({gigs:data})  
    }
    getCategories = async () => {
        let data = await categoryApi.get('/').then(({data})=>data);
        this.setState({categories:data})
    }
    delGig = async (id) => {
        await GigsApi.delete(`GigsApi/${id}/`)
        this.getGigs();
    }
    updateStates = (id,title,category,price,details,images) => {
        this.setState({ id:id, title:title,category:category,price:price,details:details,image:images,img_update:'no'});
    }
    handleTitle = (e) => {
        console.log('hi');
        this.setState({title:e.target.value})
    }
    handleCategory = (e) => {
        this.setState({category:e.target.value})
    }
    handleDetails = (event, editor) => {
        this.setState({details:editor.getData()})
    }
    handlePrice = (e) => {
        this.setState({price:e.target.value})
    }
    handleImage = (e) => {
        this.setState({image:e.target.files[0]})
    }
    updateGig  = async () => {
        let data = new FormData();
        data.append('title', this.state.title);
        data.append('category', this.state.category);
        data.append('price', this.state.price);
        data.append('details', this.state.details);
        await GigsApi.put(`GigsApi/${this.state.id}/`,data)
        this.getGigs();
    }
    updateGigImg  = async () => {
        let data = new FormData();
        data.append('title', this.state.title);
        data.append('category', this.state.category);
        data.append('price', this.state.price);
        data.append('details', this.state.details);
        data.append('images', this.state.image,this.state.image.name);
        await GigsApi.put(`GigsApi/${this.state.id}/`,data)
        this.getGigs();
    }
    img = () => {
        this.setState({ img_update:'yes'});
    }
    render() {
    return(
    <>
        <div className='container mt-5 pt-5 mx-5 px-5'>
            <h1>Gigs</h1><br/>
            <button className='btn btn-primary float-right' type='submit' style={{color: 'black',backgroundColor: '#0275d8',fontSize:'13px'}}><Link  to='/add'><b>CREATE A NEW GIG</b></Link></button><br/>
            <hr/>
            <div className='container mx-2 w3-light-gray'>
                <h5><b><br/>ACTIVE GIGS</b></h5>
                <table className="table">
                <thead>
                    <tr>
                    <th style={{width:'40%'}} >GIG Title</th>
                    <th style={{width:'15%'}}>Category</th>
                    <th style={{width:'10%'}}><span style={{fontSize:'10px'}}>Orders_Completed</span></th>
                    <th style={{width:'10%'}}>Ratings</th>
                    <th style={{width:'10%'}}>Price</th>
                    <th style={{width:'15%'}}>Action</th>
                    </tr>
                </thead>
                <tbody>

                        {this.state.gigs.map(a =>
                            <tr key={a.id}>
                                <td>{a.title}</td> 
                                <td>{this.state.categories.filter(x => x.id === a.category).map(x => x.name)}</td>
                                <td>{a.completed_orders}</td>
                                <td>

                                    <p style={{fontSize:'12px'}}> 
                                        {a.average_rating.rating__avg !== null ?[ ...Array(5)].map((star, i) => {
                                                const ratingValue = i+1;
                                                const val= (a.average_rating - ratingValue)+1;
                                                return(
                                                    <>
                                                    <label>
                                                    {(val > 0 && val<1) ? 
                                                        <i className='fas fa-star-half-alt' style={{color:'#ffc107'}} />
                                                    :
                                                        <i className='fas fa-star star' 
                                                        style={{ color:ratingValue <= ( a.average_rating ) ? '#ffc107' : '#D3D3D3'}} />
                                                    }
                                                    </label>
                                                    </>
                                                );
                                            }):'Not rated'}
                                        </p>

                                </td>
                                <td>{a.price * 1}</td>
                                <td ><button title='Delete Gig' style={{border: 'none',backgroundColor: 'transparent'}} onClick={() => this.delGig(a.id)}><i className='fa fa-trash' style={{fontSize:'20px',color:'red'}}/> </button> <span>   </span>
                                <button title='Edit Gig' style={{border: 'none',backgroundColor: 'transparent'}} data-bs-toggle="modal" data-bs-target="#updateCategory" onClick={() => this.updateStates(a.id,a.title,a.category,a.price,a.details,a.images)}><i className='fa fa-edit' style={{fontSize:'20px',color:'#0275d8'}}/></button></td>
                            </tr>
                        )}
                        
                </tbody>
                </table>
                <br/>
            </div>
        </div>
        
        <div className="modal fade" id="updateCategory" tabIndex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Update Category</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    <form>
                    <div className="mb-3">
                        <label className="col-form-label">Title:</label>
                        <input type="text" className="form-control" name="title" onChange={this.handleTitle} value={this.state.title}/>
                    </div>

                    <div className="mb-3">
                        <label className="col-form-label">Category:</label>
                        <select className="form-select form-control" aria-label="Default select example" onChange={this.handleCategory} value={this.state.category}>
                            {this.state.categories.map(b =>
                                <option key={b.id} value={b.id}>
                                    {b.name}            
                                </option>
                            )}
                        </select>
                    
                    </div>
                    { (this.state.img_update === 'no') ?
                    <div className="mb-3">
                        <label className="col-form-label">Image :</label><br/>
                        <div className='container' style={{position: 'relative',height: '80px' , width: '90px'}}>
                            <img src={`${this.state.image}`} alt='...' style={{height: '90px' , width: '100px'}} /><br/>
                            <button onClick={this.img} style={{position: 'absolute',top: '0%',left: '90%',backgroundColor:'transparent', backgroundRepeat:'no-repeat',border: 'none',cursor:'pointer',overflow: 'hidden',outline:'none'}}>
                            <i className='fa fa-window-close' style={{fontSize:'24px',color:'white'}}></i></button>
                        </div>
                    </div>
                    :
                    <div className="mb-3">
                        <label className="col-form-label">Image :</label>
                        <input type="file" className="form-control" name="image_url" onChange={this.handleImage}/>
                    </div>
                    }

                    <div className="mb-3">
                        <label className="col-form-label">Price:</label>
                        <input className="form-control" name="price" onChange={this.handlePrice} value={this.state.price}/>
                    </div>
                    
                    <div className="mb-3">
                        <label className="col-form-label">Details:</label>
                        <CKEditor editor={ ClassicEditor} onChange={this.handleDetails} data={this.state.details}  />
                    </div>
                    
                    </form>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    { (this.state.img_update === 'no') ?
                        <button type="reset" className="btn btn-primary"  data-bs-dismiss="modal" onClick={this.updateGig}>Submit</button>
                        :
                        <button type="reset" className="btn btn-primary"  data-bs-dismiss="modal" onClick={this.updateGigImg}>Submit</button>
                    }
                </div>
                </div>
            </div>
            </div>
    </>
    )
    }
} 
export default SellerGigs;